<div class="carousel">
    <ng-container *ngFor="let slide of slides; let i = index">
        <div *ngIf="i === currentSlide" class="slide-container">
            <img style="max-height: 100%; max-width: 100%; object-fit: contain;" 
                 [src]="slide.src" 
                 [alt]="slide.description" 
                 class="slide" />
            <div class="slide-info" *ngIf="slide.description">
                <p class="text-white bg-dark bg-opacity-75 p-2 rounded m-2">{{ slide.description }}</p>
            </div>
        </div>
    </ng-container>

    <!-- Indicadores de posição -->
    <div class="indicators" *ngIf="slides.length > 1">
        <span *ngFor="let slide of slides; let i = index" 
              class="indicator" 
              [class.active]="i === currentSlide"
              (click)="currentSlide = i">
        </span>
    </div>

    <!-- Contador de imagens -->
    <div class="image-counter" *ngIf="slides.length > 1">
        <span class="text-white bg-dark bg-opacity-75 px-2 py-1 rounded">
            {{ currentSlide + 1 }} / {{ slides.length }}
        </span>
    </div>

    <button class="control prev" (click)="onPreviousClick()" *ngIf="slides.length > 1">
        <span class="arrow left"></span>
    </button>
    <button class="control next" (click)="onNextClick()" *ngIf="slides.length > 1">
        <span class="arrow right"></span>
    </button>
    
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close color="primary">
            <mat-icon>close</mat-icon>
        </button>
    </mat-dialog-actions>
</div>